import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { navigationLinks } from '../data/mockData';
import './About.css';

const NotFound = () => (
  <>
    <SEO
      title="Page introuvable | Symplicity"
      description="La page que vous recherchez n'existe pas ou a été déplacée."
      robots="noindex, follow"
    />
    <div className="about-page" data-testid="notfound-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title fade-in-up">Page introuvable</h1>
          <p className="page-subtitle fade-in-up" style={{ animationDelay: '0.1s' }}>
            La page que vous cherchez n'existe pas ou a été déplacée. Voici de quoi
            reprendre votre visite.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="notfound-links fade-in-up">
            {navigationLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="btn-secondary"
                data-testid={`notfound-link-${link.path === '/' ? 'home' : link.path.slice(1)}`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  </>
);

export default NotFound;
